<script>
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'consignmentScan',
    setup() {},
})
</script>

<template>
  <q-layout>
    <q-page-container>
      <q-page>
        <div class="q-mt-sm q-pl-sm">
          <div class="row">
            <div class="col-sm-12">
              <h1 class="q-ml-sm q-mt-lg">Awaiting Receipt</h1>
            </div>
          </div>
        </div>
      </q-page>
    </q-page-container>
  </q-layout>

</template>
